/* ===== Lucky Bag – Product Countdown (hide after cutoff) ===== */
(function () {
  // Only run on product pages
  if (!/\/products\//i.test(window.location.pathname)) return;

  // Use DOMContentLoaded for better performance
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    // Cache DOM elements
    const wrapper = document.getElementById('timer-display');
    const box = document.getElementById('countdown');
    const hEl = document.getElementById('hours');
    const mEl = document.getElementById('minutes');
    const sEl = document.getElementById('seconds');
    
    // Early exit if elements don't exist
    if (!wrapper || !box || !hEl || !mEl || !sEl) return;

    // === Settings ===
    const CUTOFF_HOUR = 16;   // 4:30 PM
    const CUTOFF_MIN = 30;
    const HIDE_ON_WEEKEND = true;

    // Helper function to pad numbers
    const pad2 = (n) => String(n).padStart(2, '0');

    // Get today's cutoff time
    function getTodayCutoff() {
      const now = new Date();
      return new Date(now.getFullYear(), now.getMonth(), now.getDate(), CUTOFF_HOUR, CUTOFF_MIN, 0, 0);
    }

    // Check if timer should be hidden
    function shouldHide() {
      const now = new Date();
      const day = now.getDay(); // 0=Sunday, 6=Saturday
      
      // Hide on weekends
      if (HIDE_ON_WEEKEND && (day === 0 || day === 6)) return true;
      
      // Hide after cutoff time
      if (now >= getTodayCutoff()) return true;
      
      return false;
    }

    // Hide timer
    function hide() {
      wrapper.style.display = 'none';
    }

    // Show timer
    function show() {
      wrapper.style.display = '';
      box.style.display = 'inline-flex';
    }

    // Check if we should hide immediately
    if (shouldHide()) {
      hide();
      return;
    }

    // Show timer and start countdown
    show();
    const deadline = getTodayCutoff();
    let interval;

    // Update countdown
    function tick() {
      // Check if we should hide during the session
      if (shouldHide()) {
        hide();
        clearInterval(interval);
        return;
      }

      const now = Date.now();
      const distance = deadline.getTime() - now;

      // Calculate time remaining
      const hours = Math.floor((distance % (24 * 3600000)) / 3600000);
      const minutes = Math.floor((distance % 3600000) / 60000);
      const seconds = Math.floor((distance % 60000) / 1000);

      // Update DOM (use textContent for better performance)
      hEl.textContent = pad2(Math.max(0, hours));
      mEl.textContent = pad2(Math.max(0, minutes));
      sEl.textContent = pad2(Math.max(0, seconds));
    }

    // Initial tick and start interval
    tick();
    interval = setInterval(tick, 1000);
  }
})();